import * as types from "../types";

export const createMeeting = ({ meetingSlotId }) => ({
  type: types.CREATE_MEETING,
  request: {
    url: "/meetings",
    method: "POST",
    data: {
      meeting: {
        meetingSlotId
      }
    }
  }
});

export const getMeetings = () => ({
  type: types.GET_MEETINGS,
  request: {
    url: "/meetings",
    method: "GET"
  }
});

export const getMeeting = ({ id }) => ({
  type: types.GET_MEETING,
  request: {
    url: `/meetings/${id}`,
    method: "GET"
  }
});

export const deleteMeeting = ({ id }) => ({
  type: types.DELETE_MEETING,
  request: {
    url: `/meetings/${id}`,
    method: "DELETE"
  },
  meta: {
    mutations: {
      [types.GET_MEETINGS]: ({ data }) => {
        return { data: data.filter(m => m.id !== id) };
      },
      [types.GET_PROFILE_MEETING_SLOTS]: ({ data }) => {
        return {
          data: data.map(ms => (ms.meeting?.id === id ? { ...ms, meeting: undefined } : ms))
        };
      }
    }
  }
});

export const updateMeetingSlot = ({ id, meetingSlot }) => ({
  type: types.UPDATE_MEETING_SLOT,
  request: {
    url: `/meeting_slots/${id}`,
    method: "PATCH",
    data: {
      meetingSlot
    }
  },
  meta: {
    mutations: {
      [types.GET_PROFILE_MEETING_SLOTS]: ({ data }) => {
        return { data: data.map(ms => (ms.id === id ? { ...ms, ...meetingSlot } : ms)) };
      }
    }
  }
});
